import { VesselProductMessage } from '../../../../types/VesselProductMessage';
import { DropdownMenu, DropdownMenuOption } from '../../../cdl/DropdownMenu/DropdownMenu';
import { translate } from '../../../common/helpers/translate.helper';

interface VesselProductRowActionsDropdownProps {
    vesselProduct: VesselProductMessage;
    onEdit: () => void;
    onRemove: () => void;
}

export const VesselProductRowActionsDropdown = ({
    vesselProduct,
    onEdit,
    onRemove,
}: VesselProductRowActionsDropdownProps) => {
    const removeOption: DropdownMenuOption = {
        label: translate('vessel.products.actions.remove'),
        destructive: true,
        onSelect: (event) => {
            event?.stopPropagation?.();
            onRemove();
        },
    };

    const options: DropdownMenuOption[] = vesselProduct.product.archived
        ? [removeOption]
        : [
              {
                  label: translate('vessel.products.actions.edit'),
                  onSelect: (event) => {
                      event?.stopPropagation?.();
                      onEdit();
                  },
              },
              removeOption,
          ];

    return <DropdownMenu align="end" options={options} />;
};
